import styles from "./PublishingMethodSelector.module.css";

// ====================================
//  Publishing method tabs.
//  Each maps to a backend PublishingMethodScope:
//    jabi        -> JABI
//    jabi-amazon -> BOTH
//    amazon      -> AMAZON
// ====================================
const METHODS = [
    { value: "jabi", label: "자비 출판" },
    { value: "jabi-amazon", label: "자비 출판 + 아마존 킨들" },
    { value: "amazon", label: "아마존 킨들" },
];

function PublishingMethodSelector({ value, onChange }) {
    return (
        <div className={styles["pms-wrapper"]}>
            <div className={styles["pms-label"]}>출판 방식</div>
            <div className={styles["pms-divider"]} />
            <div className={styles["pms-buttons"]}>
                {METHODS.map((method) => (
                    <button
                        key={method.value}
                        className={`${styles["pms-btn"]}${value === method.value ? " " + styles["active"] : ""}`}
                        onClick={() => onChange(method.value)}
                        type="button"
                    >
                        {method.label}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default PublishingMethodSelector;
